import type { PageHelpContent } from './types';

export const broadcastQueueHelp: PageHelpContent = {
  pageGuide: {
    title: 'Как работает очередь рассылок',
    body: [
      'Здесь лежат сообщения, которые система подготовила к отправке пациентам: напоминания о записи, просьбы подтвердить запись, сообщения для сбора обратной связи и другие уведомления.',
      'Если включён ручной режим, сообщение сначала попадает сюда. Перед отправкой администратор может проверить текст, канал и при необходимости поменять канал.',
    ],
  },
  expandedGuide: {
    title: '',
    body: [
      'Значок с глазом открывает проверку перед отправкой: какой текст увидит пациент, какие будут кнопки, какая ссылка уйдёт в SMS и через какой канал сообщение пойдёт.',
      'Если в карточке пациента уже выбран свой канал, система берёт его. Если такого выбора нет, используется общий порядок каналов из раздела Settings.',
      'Если сообщение ещё не отправлено, смена канала просто заменяет канал до отправки. Если сообщение уже отправляли или оно завершилось ошибкой, смена канала готовит повторную отправку. В таблице это видно по значкам ✎ и 🔄.',
      'Кнопка «Отправить тест себе» нужна для проверки. Первый режим отправляет вам сообщение ровно в том виде, как оно сейчас стоит в очереди. Второй режим заново собирает сообщение перед отправкой и помогает проверить ссылки, кнопки и подстановку данных.',
      'Быстрые даты считаются по смыслу сообщения. Для напоминаний кнопка «Сегодня» показывает то, что нужно отправить сегодня на завтрашние записи. Для сбора обратной связи «Сегодня» означает пациентов, которые были на приёме сегодня.',
      'После успешной отправки статус меняется на «Отправлено». Если пациент не ответил в одном канале, можно переключиться на другой и отправить ещё раз.',
    ],
    tips: [
      'Перед кнопкой «Одобрить все» откройте 2-3 предпросмотра и проверьте текст, дату, врача и канал.',
      'Если в SMS есть ссылка, итог проверки смотрите не только здесь, но и потом в разделе «Взаимодействия пациентов».',
      'Меняйте канал только осознанно: история прошлых попыток сохраняется и помогает понять, что уже пробовали.',
    ],
  },
  tooltips: {},
};
